import {break_lg} from "../../js/constants";
import {forEach, Move} from "../../js/helpers";
import {initSlider} from "./initSlider";

if (window.innerWidth >= 768) {
  new Move(document.querySelector('[data-move="product-content-get"]'), document.querySelector('[data-move="product-content-set"]'), break_lg).init();
}

forEach(document.querySelectorAll('.productTop'), $container => initSlider($container));
